import { Floating } from './Floating'

export default Floating
